module.exports = __webpack_public_path__ + "static/Django_Balloon-11c417b2276e35901d4aac2f4a1aef10.png";